import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { brizTvApps } from './brizTvApps';
import { BrizTvApp } from './BrizTvApp';
import { GlobalRouteNames, ButtonClassNames } from '../../../models/Common';
import { useAppSelector } from '../../../hooks/redux';
import { UseGetAuthLinkBrizTv } from '../../../hooks/UseGetAuthLinkBrizTv';
import { userInfoApi } from '../../../services/apiServices/user/userInfo';
import { openNewBrowserTab } from '../../../services/domService';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { BrizTV } from '../../../models/Accounts';
import { suspensionOfServicesIds } from '../../../constants/configuration';

interface BrizTvPromotionProps {
  email: string;
  phone: string;
  password: string;
}

export const BrizTvPromotion: FC<BrizTvPromotionProps> = ({ email, phone, password }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { isSuccess } = useAppSelector((state) => state.appReducer);
  const { data: connectedAccounts } = userInfoApi.useGetConnectedAccountsQuery('');
  const { getAuthLinkBrizTv, isLoadingGetAuthLinkBrizTv } = UseGetAuthLinkBrizTv();

  const unionIptvBrizTVCredentials: BrizTV | null =
    connectedAccounts?.union_accounts?.filter(
      (el) => el?.Iptv?.BrizTV !== null && !el?.Service?.Daily && !suspensionOfServicesIds.includes(el?.Service?.id),
    )[0]?.Iptv?.BrizTV || null;

  const phoneCredential = phone || unionIptvBrizTVCredentials?.Phone;
  const emailCredential = email || unionIptvBrizTVCredentials?.Email;
  const passwordCredential = password || unionIptvBrizTVCredentials?.Password;

  const handleBrizTv = async () => {
    if (isLoadingGetAuthLinkBrizTv) return;
    const link = await getAuthLinkBrizTv();
    openNewBrowserTab(link);
  };

  if (!isSuccess) {
    history.push(GlobalRouteNames.HomePage);
  }

  return (
    <div className="success-container briz-tv-promotion">
      <h1>{t('success.brizTv.promotionIsActivated')}</h1>
      <div className="briz-tv-promotion__description">
        <p className="briz-tv-promotion__title">{t('success.brizTv.tariffNowAvailable')}</p>
      </div>
      <div className="briz-tv-promotion__login-details">
        <p className="briz-tv-promotion__title">{t('success.brizTv.toEnterUseDataProvidedDuringRegistration')}</p>
        <div className="briz-tv-promotion__login-details__table">
          {phoneCredential && (
            <>
              <div className="title">{t('success.brizTv.yourPhone')}:</div>
              <div className="value">{phoneCredential}</div>
            </>
          )}
          {emailCredential && (
            <>
              <div className="title">{t('success.brizTv.yourLogin')}:</div>
              <div className="value">{emailCredential}</div>
            </>
          )}
          <div className="title">{t('success.brizTv.yourPassword')}:</div>
          <div className="value">{passwordCredential}</div>
        </div>
        <div>
          <CustomMUIButton
            label={t('success.brizTv.startWatching')}
            className={ButtonClassNames.PrimaryFulfilled}
            handleClick={handleBrizTv}
            isBold
          />
        </div>
      </div>
      <div className="briz-tv-promotion__apps-container">
        <div className="briz-tv-promotion__apps-container__available-apps-container">
          <p className="briz-tv-promotion__title">{t('success.brizTv.orDownloadApplication')}</p>
          <div className="briz-tv-promotion__apps-container__available-apps-container__apps">
            {brizTvApps.map((app) => {
              return <BrizTvApp {...app} key={app.description} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
